
<!-- Object inspector -->

<div class="fdm-floatbar" style="min-height:900px!important;">

  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <li class="fdm-linked fdm-options-button pointer" (click)="cancel()">
      <fa-icon icon="times"></fa-icon>
    </li>

    <h2>{{ 'INSPECTOR.DETAILS' | translate }}</h2>
  </div>
  <div class="fdm-sidebar-body">

    <div *ngIf="entity">
      {{ 'INSPECTOR.SHOW' | translate }} <mat-slide-toggle color="primary" [(ngModel)]="entity.show"></mat-slide-toggle>
      <ng-container *ngIf="entity._polygon">
        {{ 'INSPECTOR.CLAMP' | translate }} <mat-slide-toggle color="primary" [(ngModel)]="entity._polygon.clampToGround"></mat-slide-toggle>
      </ng-container>
      
    </div>

      <table *ngIf="props" class="fdm-sidebar-table-list" style="margin-bottom:15px;margin-top:10px;">
    
        <tr class="darker">
          <th>{{ 'INSPECTOR.KEY' | translate }}</th>
          <th>{{ 'INSPECTOR.KEY_VALUE' | translate }}</th>
        </tr>
    
        <tr *ngFor="let k of objectKeys(props)">
          <td><b style="color:#999;"> {{k}} </b></td>
          <td> {{props[k]}} </td>
        </tr>
     
      </table>

      <div (click)="showAdvanced = ! showAdvanced">
        <div class="fdm-layer-tools">
          <fa-icon *ngIf="!showAdvanced" class="fdm-layer-icon-gray" icon="chevron-down"></fa-icon>
          <fa-icon *ngIf="showAdvanced" class="fdm-layer-icon-gray" icon="chevron-up"></fa-icon>
        </div>

        <div translate class="fdm-linked" style="padding:0 4px;">INSPECTOR.ADVANCED</div>

        <div class="clearfix"></div>
      </div>
            
      <div *ngIf="showAdvanced" class="fdm-layer-options">

        <table *ngIf="aprops" class="fdm-sidebar-table-list">
    
          <tr class="darker">
            <th>{{ 'INSPECTOR.KEY' | translate }}</th>
            <th>{{ 'INSPECTOR.KEY_VALUE' | translate }}</th>
          </tr>
      
          <tr *ngFor="let k of objectKeys(aprops)">
            <td><b style="color:#999;"> {{k}} </b></td>
            <td> {{aprops[k]}} </td>
          </tr>
    
          <tr class="darker">
            <th>{{ 'INSPECTOR.FEATURE' | translate }}</th>
            <th>{{ 'INSPECTOR.FEATURE_VALUE' | translate }}</th>
          </tr>
      
          <tr *ngFor="let k of objectKeys(features)">
            <td><b style="color:#999;"> {{k}} </b></td>
            <td> {{features[k]}} </td>
          </tr>
       
        </table>

      </div>
  </div>
</div>

<!-- not sure what this bit does? -->
<ng-template #description>
  <div #featurePropertiesDiv></div>
</ng-template>

